module.exports = __webpack_public_path__ + "static/media/selfer.5a081161.png";